import { createContext } from "react";
import type {
    DataPointMapWithBin,
    EmissionRecordMapWithBin,
} from "./CustomTypes";

export const MapDataContext = createContext<{
    allData: {
        thirdPartyEmissions: EmissionRecordMapWithBin[];
        selfReportedEmissions: EmissionRecordMapWithBin[];
        publicEmissions: DataPointMapWithBin[];
        unmatchedDataPoints: DataPointMapWithBin[];
    };
    visibleOnMap: {
        thirdPartyEmissions: EmissionRecordMapWithBin[];
        selfReportedEmissions: EmissionRecordMapWithBin[];
        publicEmissions: DataPointMapWithBin[];
        unmatchedDataPoints: DataPointMapWithBin[];
    };
    filteredByContext: {
        thirdPartyEmissions: EmissionRecordMapWithBin[];
        selfReportedEmissions: EmissionRecordMapWithBin[];
        publicEmissions: DataPointMapWithBin[];
        unmatchedDataPoints: DataPointMapWithBin[];
    };
    loading: boolean;
}>(null);
